/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./contact-view.vue?vue&type=template&id=71187a38&scoped=true"
import script from "./contact-view.vue?vue&type=script&lang=js"
export * from "./contact-view.vue?vue&type=script&lang=js"
import style0 from "./contact-view.vue?vue&type=style&index=0&id=71187a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71187a38",
  null
  
)

export default component.exports